import { queryOptions } from "@tanstack/react-query";
import type { Server, ServerResponse } from "@/app/servers/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { serversKeys } from "./query-keys";

const fetchServers = async ({
  client,
}: {
  client: ApiClient;
}): Promise<Server[]> => {
  const { data } = await client.get<ServerResponse>("/workers");
  return data?.items ?? [];
};

export const serversQueryOptions = ({
  binding = "project",
  scope,
}: {
  binding?: ScopedBinding;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<Server[]>({
    queryKey: serversKeys.list({ binding, scope }),
    queryFn: () => fetchServers({ client }),
  });
};
